/**
 * @module app.track.facts
 */
import appBase from '../index.js';

class Controller {
  /**
   * @param {app.track.service} appTrackService
   * @param {ui.router.$state} $state
   * @ngInject
   */
  constructor(appTrackService, $state) {
    /**
     * @export
     * @type {function(appx.TimetypeChangeEvent)}
     */
    this.onSetTimetype;

    /**
     * @type {app.track.service}
     * @export
     */
    this.appTrackService = appTrackService;

    /**
     * @type {ui.router.$state}
     * @private
     */
    this.routingState_ = $state;
  }

  get track() {
    return this.appTrackService.selectedTrack;
  }

  /**
   * @export
   * @return {boolean}
   */
  isEditable() {
    return this.appTrackService.ownSelectedTrack() && !document.body.classList.contains('in-maintenance');
  }

  /**
   * @export
   * @return {string}
   */
  routingStateName() {
    return this.routingState_.current.name;
  }
}

/**
 * @const {!angular.Component}
 */
const component = {
  bindings: {
    'factsError': '=?',
    'factsLoading': '=?',
    'onSetTimetype': '&'
  },
  controller: Controller,
  templateUrl: 'js/app/track/facts/partial.html',
};

export default appBase.component('appTrackFacts', component);
